import { MANUAL_DURATION_STEP, MAX_MANUAL_DURATION, MIN_MANUAL_DURATION } from './AvailabilityTimeSlotManual.types';

export const isManualTimeSlotInvalid = (slotDuration: number | null): boolean => {
   return (
      !slotDuration ||
      slotDuration % MANUAL_DURATION_STEP !== 0 ||
      slotDuration > MAX_MANUAL_DURATION ||
      slotDuration < MIN_MANUAL_DURATION
   );
};
